import React, { useEffect } from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import QuoteSelectionWasteService from "../QouteSelectionWasteService";

const QuotesGenerated = ({ whitelabelIconLink, whitelabelCompanyName }) => {
  const context = useOutletContext();
  const navigate = useNavigate();
  const customerDetails = context[1];
  const services = context[2];

  useEffect(() => {
    if (customerDetails?.postcode === "") {
      navigate("/quote/postcode");
      return;
    } else if (services.length === 0) {
      navigate("/quote/waste-services");
      return;
    } else if (customerDetails?.email === "") {
      navigate("/quote/email");
      return;
    }
  }, []);

  return (
    <div className="w-full p-4 xl:p-6 2xl:p-8">
      <div className="border-b border-slate-600 pb-3 lg:border-b-2 lg:pb-5">
        <p className="pb-3 text-base text-black md:text-lg lg:pb-5 lg:text-lg xl:pb-8 xl:text-xl">
          Thank you for generating a quote. {whitelabelCompanyName} will get in
          touch with you about the sale.
        </p>
        <div className="flex flex-col items-start gap-3">
          {whitelabelIconLink !== null && (
            <a
              className="rounded-md border border-transparent bg-primaryColor px-2 py-1 text-center text-xs text-secondaryColor shadow-md transition-all hover:border-hoverColor hover:bg-hoverColor hover:text-white hover:shadow-lg focus:border-hoverColor focus:bg-hoverColor focus:text-white active:border-hoverColor active:bg-hoverColor active:text-white md:text-sm lg:text-sm"
              href={whitelabelIconLink}
            >
              Return to {whitelabelCompanyName}
            </a>
          )}
        </div>
      </div>
      <h2 className="mb-1 mt-3 text-base font-bold text-black md:text-sm lg:mb-2 lg:mt-5 lg:text-xl xl:mb-3 xl:mt-8 xl:text-2xl 2xl:mb-4 2xl:mt-12 2xl:text-3xl">
        Selected Services
      </h2>
      {services?.map((service, index) => (
        <QuoteSelectionWasteService selectedService={service} key={index} />
      ))}
    </div>
  );
};

export default QuotesGenerated;
